import { get, post, put, del } from '@/lib/api/client'
import type {
  ApiResponse,
  PaginatedResponse,
  Folder,
  FolderListItem,
  CreateFolder,
  UpdateFolder,
  FolderSearchParams,
  PaginationParams
} from '@/lib/api/types'

export const folderService = {
  // Create a new folder
  createFolder: async (data: CreateFolder): Promise<ApiResponse<Folder>> => {
    return await post<ApiResponse<Folder>>(
      'folders/admin/private',
      data
    )
  },

  // Update an existing folder
  updateFolder: async (
    folderId: string,
    data: UpdateFolder
  ): Promise<ApiResponse<null>> => {
    return await put<ApiResponse<null>>(
      `folders/admin/private/${folderId}`,
      data
    )
  },

  // Delete a folder
  deleteFolder: async (folderId: string): Promise<ApiResponse<null>> => {
    return await del<ApiResponse<null>>(
      `folders/admin/private/${folderId}`
    )
  },

  // Get paginated list of private folders (optionally filtered by folderType)
  getFolders: async (
    params: PaginationParams = { page: 1, size: 10 },
    folderType?: 'VIDEO' | 'PHOTO'
  ): Promise<ApiResponse<PaginatedResponse<FolderListItem>>> => {
    let url = `folders/private/filter?page=${params.page}&size=${params.size}`
    if (folderType) {
      url += `&folderType=${folderType}`
    }
    return await get<ApiResponse<PaginatedResponse<FolderListItem>>>(url)
  },

  // Get folder by ID
  getFolderById: async (folderId: string): Promise<ApiResponse<FolderListItem>> => {
    return await get<ApiResponse<FolderListItem>>(
      `folders/private/${folderId}`
    )
  },

  // Search folders by name
  searchFolders: async (
    params: FolderSearchParams
  ): Promise<ApiResponse<PaginatedResponse<Folder>>> => {
    const queryParams = Object.entries(params)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&')
    return await get<ApiResponse<PaginatedResponse<Folder>>>(
      `folders/private/search?${queryParams}`
    )
  }
}
